import React, { memo, useCallback, useContext } from 'react'
import { Timeline, Space, Button, Popconfirm } from 'antd'
import { FileOutlined, CopyOutlined, DeleteOutlined, DownloadOutlined } from '@ant-design/icons'
import { TimeLineContentWrapper, TimeLineContentHeaderWrapper } from '../../../styles/styles'
import filesize from 'filesize'
import { ActivityFile } from '../../../types/types'
import DotIcon from '../../../lib/components/dot-icon/diot-icon'
import TimelineItemHeader from '../activity-timeline-item-header/activity-timeline-item-header'
import cls from './activity-timeline-file.module.css'
import { caseDeleteFile } from '../../../../../../store/appeals/actions'
import { TimelineItemProps } from '../activity-timeline-Item'
import { ActivityTimelineContext } from '../../../context/activity-timeline-context'
import ImagePreview from "./image-preview/image-preview";
import { useAppDispatch } from '../../../../../../hooks/useAppDispatch/useAppDispatch'

type ActivityTimelineFileType = Omit<TimelineItemProps, 'data'>
interface ActivityTimelineFileProps extends ActivityTimelineFileType {
  className?: string
  data?: ActivityFile
}

const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp']

const isImageFile = (fileName: string): boolean => {
  const extension = fileName.toLowerCase().slice(fileName.lastIndexOf('.'))
  return imageExtensions.includes(extension)
}

const ActivityTimelineFile: React.FC<ActivityTimelineFileProps> = memo((props: ActivityTimelineFileProps) => {
  const { date, data, index, scopeDate } = props
  const dispatch = useAppDispatch()
  const { deleteTimelineItem, readFiles } = useContext(ActivityTimelineContext)

  const deleteFile = useCallback(async id => {
    await dispatch(caseDeleteFile({id}))
      deleteTimelineItem?.({ date: scopeDate, index, data: { id } }
    )
  }, [scopeDate, dispatch, deleteTimelineItem])

  return (
    <>
      <TimeLineContentWrapper>
        <TimeLineContentHeaderWrapper>
          <TimelineItemHeader date={date} title={data?.title || 'Файл'}/>
        </TimeLineContentHeaderWrapper>
        <Space style={{display: 'block'}}>
          {data?.files?.length && data.files.map((item, index) => (
            <Space key={`${item?.name}${item?.type}${index}`}>
              {item.name && isImageFile(item.name) ? (
                <>
                  <div className={cls.imageWrapper}>
                    <ImagePreview imageUrl={item.url} alt={item.name} width={100} height={100} />
                  </div>
                  {
                    item?.size !== undefined && item.size > 0 && (
                      <span className={cls.fileSize}>
                        {`(${filesize(item.size)})`}
                      </span>
                    )
                  }
                  <Button
                    className={cls.button}
                    onClick={() => {
                      window.location.href = item.url;
                    }}
                  >
                    <DownloadOutlined />
                  </Button>
                </>
              ) : (
                <>
                  <a href={item.url} className={cls.fileName}>
                    {item.name}
                  </a>
                  {
                    item?.size !== undefined && item.size > 0 && (
                      <span className={cls.fileSize}>
                        {`(${filesize(item.size)})`}
                      </span>
                    )
                  }
                </>
              )}
              <Button
                className={cls.button}
                onClick={() => {window?.navigator?.clipboard?.writeText(item.url)}}
              >
                <CopyOutlined/>
              </Button>
              {
                !readFiles && <Button className={cls.button}>
                  <Popconfirm
                    title="Удалить файл?"
                    onConfirm={() => deleteFile(data?.id)}
                  >
                    <DeleteOutlined />
                  </Popconfirm>
                </Button>
              }
            </Space>
          ))}
        </Space>
      </TimeLineContentWrapper>
    </>
  )
})

export default ActivityTimelineFile

